import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import GraphSummaryListing from '@/modules/dashboard/components/GraphSummary/GraphSummaryListing'

const mockData = [
	{
		week: '25 Jan',
		deposits: 150000,
		firstDeposits: 45000,
		withdrawals: 80000,
		bonus: 12000,
	},
	{
		week: '26 Jan',
		deposits: 180000,
		firstDeposits: 38000,
		withdrawals: 95000,
		bonus: 15000,
	},
	{
		week: '27 Jan',
		deposits: 220000,
		firstDeposits: 52000,
		withdrawals: 110000,
		bonus: 18000,
	},
	{
		week: '28 Jan',
		deposits: 195000,
		firstDeposits: 41000,
		withdrawals: 88000,
		bonus: 14000,
	},
	{
		week: '29 Jan',
		deposits: 210000,
		firstDeposits: 48000,
		withdrawals: 105000,
		bonus: 16000,
	},
	{
		week: '30 Jan',
		deposits: 185000,
		firstDeposits: 39000,
		withdrawals: 92000,
		bonus: 13000,
	},
	{
		week: '31 Jan',
		deposits: 230000,
		firstDeposits: 55000,
		withdrawals: 115000,
		bonus: 19000,
	},
]

const userData = [
	{
		week: '25 Jan',
		activeUsers: 12,
		firstDeposits: 8,
		newUsers: 4,
	},
	{
		week: '26 Jan',
		activeUsers: 15,
		firstDeposits: 10,
		newUsers: 5,
	},
	{
		week: '27 Jan',
		activeUsers: 18,
		firstDeposits: 12,
		newUsers: 6,
	},
	{
		week: '28 Jan',
		activeUsers: 20,
		firstDeposits: 14,
		newUsers: 7,
	},
	{
		week: '29 Jan',
		activeUsers: 21,
		firstDeposits: 15,
		newUsers: 8,
	},
	{
		week: '30 Jan',
		activeUsers: 22,
		firstDeposits: 16,
		newUsers: 9,
	},
	{
		week: '31 Jan',
		activeUsers: 23,
		firstDeposits: 17,
		newUsers: 10,
	},
]

function GraphSummaryPage() {
	return (
		<PageContainer>
			<GraphSummaryListing data={mockData} userData={userData} />
		</PageContainer>
	)
}

const GuardedGraphSummaryPage = withUserPermission(GraphSummaryPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_MARKETING],
})

export default GuardedGraphSummaryPage
